import { render } from "./index.vue?vue&type=template&id=5bd357a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5bd357a8&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=5bd357a8&lang=scss"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd357a8"],['__file',"src/components/more/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bd357a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bd357a8', __exports__)) {
    console.log('reload')
    api.reload('5bd357a8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5bd357a8&scoped=true", () => {
    console.log('re-render')
    api.rerender('5bd357a8', render)
  })

}


export default __exports__